import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "headerTitleInput", "headerSubtitleInput", "footerTitleInput", "footerSubtitleInput",
    "headerTitle", "headerSubtitle", "footerTitle", "footerSubtitle"
  ]

  connect() {
    this.update()
  }

  update() {
    this.headerTitleTarget.textContent = this.headerTitleInputTarget.value
    this.headerSubtitleTarget.textContent = this.headerSubtitleInputTarget.value
    this.footerTitleTarget.textContent = this.footerTitleInputTarget.value
    this.footerSubtitleTarget.textContent = this.footerSubtitleInputTarget.value
  }
}
